import type { AdItem } from '@sbt-web/network/types';
import { buildAdDetailTarget } from '@sbt-web/tracking';
import { getAdId } from '@sbt-web/utils';
import { getOrCreatePulse } from '@/tools/tracking/utils';

export const adsPublishedDialogView = (item: AdItem): void => {
  const adId = getAdId(item.urn);
  const { object: ClassifiedAd } = buildAdDetailTarget(item);

  getOrCreatePulse()?.queueEvent({
    type: 'Engagement',
    object: {
      type: 'UIElement',
      id: 'click-on-socialization-annunci-pubblicati',
    },
    target: {
      ...ClassifiedAd,
      id: adId,
    },
  });
};
